"use strict";

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Queue = void 0;

var Queue = /*#__PURE__*/function () {
  function Queue() {
    _classCallCheck(this, Queue);

    this._store = [];
  }

  _createClass(Queue, [{
    key: "pushBack",
    value: function pushBack(val) {
      this._store.push(val);
    }
  }, {
    key: "pushFront",
    value: function pushFront(val) {
      this._store.unshift(val);
    }
  }, {
    key: "popFront",
    value: function popFront() {
      return this._store.shift();
    }
  }, {
    key: "popBack",
    value: function popBack() {
      if (this._store.length === 0) {
        return undefined;
      }

      var backElement = this._store.splice(-1, 1)[0];

      return backElement;
    }
  }, {
    key: "mergeBack",
    value: function mergeBack(q) {
      this._store = this._store.concat(q._store);
    }
  }, {
    key: "mergeFront",
    value: function mergeFront(q) {
      this._store = q._store.concat(this._store);
    }
  }, {
    key: "getStore",
    value: function getStore() {
      return this._store;
    }
  }, {
    key: "peekFront",
    value: function peekFront() {
      return this._store.length >= 0 ? this._store[0] : undefined;
    }
  }]);

  return Queue;
}();

exports.Queue = Queue;